const FASHION_FOOTLOCKER_STORE = ['nf', 'fl'];
export default {
    FASHION_FOOTLOCKER_STORE,
};
